import { Card, Col, Row, Typography } from "antd";
import { useGetUserCountQuery } from "api";
import { OBJ_COLOR } from "commons/constants";

const { Title, Text } = Typography;

interface CardCustomProps {
	color: string;
	title: string;
	value: number;
}

const CardCustom = ({ color, title, value }: CardCustomProps) => (
	<Card
		bordered={false}
		style={{
			borderTop: `1px solid ${color}`,
			borderRadius: 6,
			boxShadow: "0 .125rem .25rem rgba(0,0,0,.075)",
			textAlign: "center",
		}}>
		<Title style={{ margin: 0, color: color }}>{value}</Title>
		<Text type="secondary">{title}</Text>
	</Card>
);

export const HighLightCard = () => {
	const { data } = useGetUserCountQuery();
	return (
		<Row gutter={[30, 30]}>
			<Col xs={24} sm={6}>
				<CardCustom color={OBJ_COLOR.WARNING} title={"Tổng"} value={data?.total || 0} />
			</Col>
			<Col xs={24} sm={6}>
				<CardCustom color={OBJ_COLOR.DANGER} title={"Chưa xem"} value={data?.notSeen || 0} />
			</Col>
			<Col xs={24} sm={6}>
				<CardCustom color={OBJ_COLOR.INFO} title={"Đã xem"} value={data?.seen || 0} />
			</Col>
			<Col xs={24} sm={6}>
				<CardCustom color={OBJ_COLOR.SUCCESS} title={"Đã hoàn thành"} value={data?.completed || 0} />
			</Col>
		</Row>
	);
};
